"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-misused-promises*/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Table_1 = __importDefault(require("@mui/material/Table"));
var TableBody_1 = __importDefault(require("@mui/material/TableBody"));
var TableCell_1 = __importDefault(require("@mui/material/TableCell"));
var TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
var TableHead_1 = __importDefault(require("@mui/material/TableHead"));
var TableRow_1 = __importDefault(require("@mui/material/TableRow"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var material_1 = require("@mui/material");
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
var DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
var DialogContentText_1 = __importDefault(require("@mui/material/DialogContentText"));
var DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var react_hot_toast_1 = __importStar(require("react-hot-toast"));
var AxiosClient_1 = require("../../utils/AxiosClient");
function getCookie(name) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    var gettoken = js_cookie_1.default.get(name);
    return gettoken;
}
var token = getCookie("token");
var roles = [
    {
        value: "admin",
        label: "Admin",
    },
    {
        value: "user",
        label: "User",
    },
    {
        value: "seller",
        label: "Seller",
    },
];
function RolePermission() {
    var _this = this;
    var _a = React.useState([]), usersData = _a[0], setUsersData = _a[1];
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var _c = React.useState(""), email = _c[0], setEmail = _c[1];
    var _d = React.useState(""), role = _d[0], setRole = _d[1];
    var _e = React.useState(""), emailError = _e[0], setEmailError = _e[1];
    var _f = React.useState(""), roleError = _f[0], setRoleError = _f[1];
    var _g = React.useState(""), message = _g[0], setMessage = _g[1];
    var _h = React.useState(true), openMessage = _h[0], setOpenMessage = _h[1];
    var _j = React.useState(false), loading = _j[0], setLoading = _j[1];
    var _k = React.useState(false), doneUpdating = _k[0], setDoneUpdating = _k[1];
    var handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    react_hot_toast_1.default.loading("Please wait ....");
                    setLoading(true);
                    if (!(email == "")) return [3 /*break*/, 1];
                    setEmailError("Email is required");
                    return [3 /*break*/, 4];
                case 1:
                    if (!(role == "")) return [3 /*break*/, 2];
                    setRoleError("Role is required");
                    return [3 /*break*/, 4];
                case 2:
                    setEmailError("");
                    setRoleError("");
                    return [4 /*yield*/, AxiosClient_1.AxiosClient.patch("/authorize", {
                            email: email,
                            roleName: role,
                        }, { headers: { Authorization: "Bearer ".concat(token) } })
                            .then(function (response) {
                            react_hot_toast_1.default.remove();
                            react_hot_toast_1.default.success(response.data.message);
                            console.log(response.data.message);
                            setMessage(response.data.message);
                            setDoneUpdating(true);
                        })
                            .catch(function (error) {
                            react_hot_toast_1.default.remove();
                            setLoading(false);
                            console.log(error);
                        })];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleClickOpen = function () {
        setOpen(true);
    };
    var handleClose = function () {
        setOpen(false);
        setOpenMessage(false);
    };
    (0, react_1.useEffect)(function () {
        function fetchData() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, AxiosClient_1.AxiosClient.get("/users", {
                                headers: { Authorization: "Bearer ".concat(token) },
                            })
                                .then(function (response) {
                                setUsersData(response.data.users);
                            })
                                .catch(function (error) {
                                console.log(error);
                            })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        fetchData();
    }, [doneUpdating]);
    // console.log("response data:", usersData);
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog_1.default, { open: open, onClose: handleClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
            React.createElement(DialogTitle_1.default, { id: "alert-dialog-title" }, "Set user Role"),
            React.createElement(DialogContent_1.default, null,
                !message ? null : (React.createElement(material_1.Collapse, { in: openMessage },
                    React.createElement(material_1.Alert, { severity: "success", action: React.createElement(material_1.IconButton, { "aria-label": "close", color: "inherit", size: "small", onClick: handleClose },
                            React.createElement(Close_1.default, { fontSize: "inherit" })), sx: { mb: 0.2 } }, message))),
                React.createElement(DialogContentText_1.default, { id: "alert-dialog-description" },
                    React.createElement(TextField_1.default, { value: email, onChange: function (e) { return setEmail(e.target.value); }, helperText: emailError ? emailError : "", id: "outlined-select-currency", label: "Email" }),
                    React.createElement("br", null),
                    React.createElement(TextField_1.default, { value: role, onChange: function (e) { return setRole(e.target.value); }, helperText: roleError ? roleError : "Please select your role", id: "outlined-select-currency", select: true, label: "Select", defaultValue: "SELLER", variant: "standard" }, roles.map(function (option) { return (React.createElement(MenuItem_1.default, { key: option.value, value: option.value }, option.label)); })))),
            React.createElement(DialogActions_1.default, null,
                React.createElement(material_1.Button, { onClick: handleClose }, "Cancel"),
                React.createElement(material_1.Button, { disabled: loading, onClick: function (e) { return handleSubmit(e); } }, "Submit"))),
        React.createElement("div", { style: { height: 200, width: "100%", backgroundColor: "white" } },
            React.createElement(TableContainer_1.default, { component: Paper_1.default },
                React.createElement(Table_1.default, { sx: { minWidth: 650 }, "aria-label": "simple table" },
                    React.createElement(TableHead_1.default, null,
                        React.createElement(TableRow_1.default, null,
                            React.createElement(TableCell_1.default, { align: "center" }, "First name"),
                            React.createElement(TableCell_1.default, { align: "center" }, "Last name"),
                            React.createElement(TableCell_1.default, { align: "center" }, "Email"),
                            React.createElement(TableCell_1.default, { align: "center" }, "Phone_number"),
                            React.createElement(TableCell_1.default, { align: "center" }, "Current Role"),
                            React.createElement(TableCell_1.default, { align: "center" }, "Set Role"))),
                    React.createElement(TableBody_1.default, null, usersData.map(function (row) { return (React.createElement(TableRow_1.default, { key: row.id, sx: { "&:last-child td, &:last-child th": { border: 0 } } },
                        React.createElement(TableCell_1.default, { component: "th", scope: "row", align: "center" }, row.firstName),
                        React.createElement(TableCell_1.default, { component: "th", scope: "row", align: "center" }, row.lastName),
                        React.createElement(TableCell_1.default, { component: "th", scope: "row", align: "center" }, row.email),
                        React.createElement(TableCell_1.default, { component: "th", scope: "row", align: "center" }, row.phone_number),
                        React.createElement(TableCell_1.default, { component: "th", scope: "row", align: "center" }, row.role.name),
                        React.createElement(material_1.Button, { onClick: function () {
                                handleClickOpen(), setEmail(row.email);
                            } }, "Update Role"))); }))),
                React.createElement(react_hot_toast_1.Toaster, null)))));
}
exports.default = RolePermission;
